import makeStyles from '@material-ui/core/styles/makeStyles'
import {CancelButton, NextButton, Text} from '../../1elements'
import ClientSearch from './ClientSearch'
import {validateClientSearch, validateImportType} from '../../../services/util/editChecks'
import ButtonLayoutDiv from '../../4layout/ButtonLayoutDiv'
import ImportTypeDropdown from '../../2compounds/Select/LocationImportTypeDropdown'
import {useState} from 'react'
import DataBulkImportTabTemplate from '../../5templates/DataBulkImportTabTemplate'
import ApiService from '../../../common/ApiCalls'
import {downloadCsvTemplate} from '../../../services/util/miscellaneousService'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'

const LocationTab = ({selectedClient, setSelectedClient, onNextLocation, showError, onCancel, disabled, importType, setImportType}) => {
    const classes = useStyles()
    const [isBulkImport, setIsBulkImport] = useState(false)
    const [,setIsErrorSnackbarOpen] = useState(false)
    const [templateHeaderList, setTemplateHeaderList] = useState([])

    const handleNextButton = () => {
        onNextLocation()
        if(importType === "Add multiple locations"){
            setIsBulkImport(true)
        }
    }

    const defaultTabScreen = (
        <>
            <div className={classes.formDiv}>
                <div>
                    <Text type={'fieldLabel'}>Client Name<span className={'requiredAsterisk'} >*</span></Text>
                    <ClientSearch selectedClient={selectedClient} setSelectedClient={setSelectedClient}
                                  validation={showError&&validateClientSearch(selectedClient)} disabled={disabled} />
                </div>
                <ImportTypeDropdown value={importType} onChange={setImportType} disabled={disabled}
                                    validation={showError&&validateImportType(importType)} />
            </div>

            <ButtonLayoutDiv>
                { onCancel && <CancelButton onClick={onCancel} />}
                <NextButton onClick={handleNextButton} />
            </ButtonLayoutDiv>
        </>
    )

    const downloadTemplate = async () => {
        const header = await setTemplate()
        await downloadCsvTemplate(header, setIsErrorSnackbarOpen, 'template-locations')
    }

    const setTemplate = async () => {
        const header = await ApiService().getLocationTemplate()
        const headerArray = header.split(',')
        setTemplateHeaderList(headerArray)
        return header
    }



    const handleImportApi = async (data) => {
        const userId = window.localStorage.getItem('userId')
        const clientId = getItemFromSessionStorage('selectedClient').account_id || undefined
        const clientName = getItemFromSessionStorage('selectedClient').name || undefined
        return await ApiService().bulkImportLocation(userId, data, clientId, clientName)
    }

    const formatPath = '/format/locations'

    const bulkImportTabScreen = (
        <DataBulkImportTabTemplate dataType={'Location'}
                                   downloadTemplate={downloadTemplate}
                                   setTemplate = {setTemplate}
                                   handleImportApi={handleImportApi}
                                   templateHeaderList={templateHeaderList}
                                   formatPath={formatPath}/>
    )

    return(
        <div className={classes.root}>
            <Text type={'tabHeadingSecondary'}>Add new location(s) to an existing client</Text>
            {
                isBulkImport
                    ? bulkImportTabScreen
                    : defaultTabScreen
            }
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        padding: '20px'
    },
    formDiv: {
        margin: '20px 0',
        '&>*': {
            margin: '20px 0'
        }
    }
})

export default LocationTab